
import { getComplainantStatistics,createComplainant, getComplainant, findComplainant,updateComplainantOrder } from '@/zsm-api-new/complaint.js'
const state = {

}

const mutations = {

}

const actions = {

  /**
   * 讲师处理投诉单
   * @param orderNo 订单号
   * @param orderId 订单号
   * @param complainant_mobile 投诉人手机号
   * @param complainant_name 投诉人名称
   * @param complainant_head_picture 投诉人头像
   * @param complainant_description 投诉描述
   * @param complainant_certificate 投诉凭证
   */
  updateComplainantOrder({ commit }, info) {
    return new Promise((resolve, reject) => {
      updateComplainantOrder(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 投诉统计
   * @param endDate 结束时间
   * @param startDate 开始时间
   * @param authorMobile 讲师手机号
   * */
  getComplainantStatistics({ commit }, info) {
    return new Promise((resolve, reject) => {
      getComplainantStatistics(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },



  /**
	 * 创建投诉
	 * @param orderNo 订单号
	 * @param orderId 订单号
	 * @param complainant_mobile 投诉人手机号
	 * @param complainant_name 投诉人名称
	 * @param complainant_head_picture 投诉人头像
	 * @param complainant_description 投诉描述
	 * @param complainant_certificate 投诉凭证
	 */
  createComplainant({ commit }, info) {
	  return new Promise((resolve, reject) => {
	    createComplainant(info).then(response => {
	      resolve(response)
	    }).catch(error => {
	      reject(error)
	    })
	  })
  },

  /**
 * 投诉工单详情
 * @param id 编号
 */
  getComplainant({ commit }, id) {
    return new Promise((resolve, reject) => {
      getComplainant(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 投诉单查询
   * @param orderNo 订单号
   * @param orderId 订单号
   * @param complainant_mobile 投诉人手机号
   * @param complainant_name 投诉人名称
   * @param complainant_head_picture 投诉人头像
   * @param complainant_description 投诉描述
   * @param complainant_certificate 投诉凭证
   * @param id 投诉单 id
   * @param title 课程标题
   */
  findComplainant({ commit }, info) {
    return new Promise((resolve, reject) => {
      findComplainant(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
